import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { ArrowLeft, LogIn } from "lucide-react";
import { Logo } from "../components/Logo";

function formatErr(detail) {
  if (detail == null) return "Ocorreu um erro. Tente novamente.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e?.msg || JSON.stringify(e)).join(" ");
  return String(detail);
}

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      navigate("/admin");
    } catch (err) {
      setError(formatErr(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-secondary/40 px-5">
      <div className="w-full max-w-md">
        <button onClick={() => navigate("/")} className="flex items-center gap-2 text-sm font-semibold text-muted-foreground hover:text-foreground mb-6">
          <ArrowLeft className="w-4 h-4" /> Voltar ao site
        </button>
        <div className="bg-white rounded-3xl p-8 border border-black/5 shadow-xl">
          <div className="flex items-center gap-2.5 mb-2">
            <Logo size="sm" />
          </div>
          <h1 className="font-heading font-bold text-2xl tracking-tight mt-4">Área de administração</h1>
          <p className="text-muted-foreground text-sm mt-1">Inicie sessão para gerir as viaturas.</p>

          <form onSubmit={submit} className="space-y-4 mt-7">
            <div>
              <Label htmlFor="email" className="text-sm font-semibold">Email</Label>
              <Input id="email" data-testid="login-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required className="mt-1.5 h-11 rounded-xl focus-visible:ring-primary" placeholder="email@exemplo.pt" />
            </div>
            <div>
              <Label htmlFor="password" className="text-sm font-semibold">Palavra-passe</Label>
              <Input id="password" data-testid="login-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required className="mt-1.5 h-11 rounded-xl focus-visible:ring-primary" placeholder="••••••••" />
            </div>
            {error && <p data-testid="login-error" className="text-destructive text-sm font-medium">{error}</p>}
            <Button data-testid="login-submit" type="submit" disabled={loading} className="w-full h-11 rounded-full bg-primary hover:bg-primary/90 text-primary-foreground font-semibold">
              <LogIn className="w-4 h-4 mr-2" /> {loading ? "A entrar..." : "Entrar"}
            </Button>
          </form>
        </div>
      </div>
    </div>
  );
}
